/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import * as Elements from '../InsightTimeline.styles';
import { GradientSpan } from './GradientSpan';
import { useCanvas } from '../../components/Canvas';
import { palette } from '../../../constants';
import { getStartEndDate } from '../../utils';
import { TrackTime } from './TrackTime';
import { useCharts } from '../../components/Charts';
import { Group } from '@visx/group';
export function InsightGraph(_a) {
    var durations = _a.durations, xScale = _a.xScale, _b = _a.barHeight, barHeight = _b === void 0 ? 24 : _b, _c = _a.hideRightGradient, hideRightGradient = _c === void 0 ? false : _c;
    var pointXY = useCharts().pointXY;
    var _d = useCanvas(), boundedWidth = _d.boundedWidth, margins = _d.margins, height = _d.height;
    var _e = React.useState(undefined), time = _e[0], setTime = _e[1];
    React.useEffect(function () {
        if (pointXY !== undefined) {
            var mouseDate = xScale.invert(pointXY.x);
            setTime(mouseDate);
        }
        else {
            setTime(undefined);
        }
    }, [pointXY]);
    var ticks = xScale.ticks(7);
    return (React.createElement("g", null,
        React.createElement(GradientSpan, { x: 0 - margins.left, y: margins.top, width: margins.left, height: height, left: true }),
        !hideRightGradient && (React.createElement(GradientSpan, { x: boundedWidth, y: margins.top, width: margins.right, height: height })),
        React.createElement("rect", { x: 0, y: margins.top, width: boundedWidth, height: height, fill: "#EBECFF" }),
        React.createElement("line", { x1: 0, x2: boundedWidth, y1: 0, y2: 0, stroke: "hsla(210,16%,82%,1)", strokeWidth: 1, shapeRendering: "optimizespeed" }),
        React.createElement("line", { x1: 0, x2: boundedWidth, y1: height - 1, y2: height - 1, stroke: "hsla(210,16%,82%,1)", strokeWidth: 1, shapeRendering: "optimizespeed" }),
        durations.map(function (d) {
            if (d === undefined)
                return null;
            var _a = getStartEndDate(d, xScale.domain()), start = _a.start, end = _a.end;
            var rectWidth = xScale(end) - xScale(start);
            return (React.createElement(Elements.TransitRect, { key: d.start.toString(), x: xScale(start), y: (height - barHeight) / 2, rx: rectWidth / 2 >= 8 ? 8 : rectWidth / 2, ry: rectWidth / 2 >= 8 ? 8 : rectWidth / 2, width: rectWidth, height: barHeight, fill: palette.indigo8 }));
        }),
        ticks.map(function (tick, index) { return (React.createElement("line", { key: index, x1: xScale(tick), x2: xScale(tick), y1: 0, y2: height, stroke: "#CAD1D8" })); }),
        time !== undefined && pointXY !== undefined && (React.createElement(Group, { transform: "translate(" + pointXY.x + ")" },
            React.createElement(TrackTime, { time: time })))));
}
//# sourceMappingURL=InsightGraph.js.map